import React from "react"
import { render } from "react-dom"

import Raven from "raven-js"

// Import Font Awesome Icons Set
import "@fortawesome/fontawesome-free/css/all.min.css"
// Import Simple Line Icons Set
import "simple-line-icons/css/simple-line-icons.css"

import "../scss/style.scss"
import "babel-polyfill"

import App from "App"

const environment = process.env.SENTRY_ENVIRONMENT
const dsn = process.env.SENTRY_KEY
if (dsn && environment) {
  Raven.config(dsn, { environment: environment }).install()
}

render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>,
  document.getElementById("app")
)
